<div class="box_not_found">
  <h1>404</h1>
  <p>{{ 'themes.public.not_found' | translate }}</p>
</div>
